const { default: App } = require('./App');

new App();

console.log('initialize the application here');
